import React, { Fragment } from 'react';
import { translate } from '../../Services/translation';

const CartCuttingDetails = ({ isCoilItem, specification, blastingDetails }) => {
  return (
    <Fragment>
      {isCoilItem == false && specification && (
        <Fragment>
          {specification.cutType && (
            <Fragment>
              {specification.cutType.cutCode && (
                <div>
                  {translate('checkout.cart.specification.selctioncuttingtype')}
                  : {specification.cutType.cutCode}
                  {' '}{translate('checkout.cart.specification.cutcode')}:{' '}
                  {specification.cutType.cutCode}
                </div>
              )}{' '}
              {specification.cutType.cutAngleA && (
                <div>
                  {translate('checkout.cart.specification.cutanglea')}:{' '}
                  {specification.cutType.cutAngleA}
                </div>
              )}{' '}
              {specification.cutType.cutAngleB && (
                <div>
                  {translate('checkout.cart.specification.cutangleb')}:{' '}
                  {specification.cutType.cutAngleB}
                </div>
              )}
            </Fragment>
          )}
          {specification.marking && (
            <Fragment>
              {specification.marking.drawingNumber && (
                <div>
                  {translate('checkout.cart.specification.drawingnumber')}
                  : {specification.marking.drawingNumber}
                </div>
              )}
              {specification.marking.workPhaseMarkingText && (
                <div>
                  {translate('checkout.cart.specification.selctionmarking')}
                  : {specification.marking.workPhaseMarkingText}
                </div>
              )}
              {specification.marking.workPhaseMarkingChargeNumber && (
                <div>
                  {translate('checkout.cart.specification.workphasemarkingchargenumber')}
                  :{' '}
                  {specification.marking.workPhaseMarkingChargeNumber
                    ? translate('checkout.cart.specification.workphasemarkingchargenumber.true')
                    : translate('checkout.cart.specification.workphasemarkingchargenumber.false')}
                </div>
              )}
              <p>
                {specification.marking.goodsMarking && (
                  <span>
                    {translate('checkout.cart.specification.goodsmarking')}
                    : {specification.marking.goodsMarking}
                  </span>
                )}
              </p>
            </Fragment>
          )}
          {specification.lineDetails &&
            specification.lineDetails.goodsMarkLine && (
              <div>
                {translate('checkout.cart.specification.selctionmarking')}
                : {specification.lineDetails.goodsMarkLine}
              </div>
            )}
        </Fragment>
      )}
      {isCoilItem && specification && (
        <Fragment>
          {specification.foilingCoils && (
            <div>
              {translate('checkout.cart.specification.foilingcoils')}:{' '}
              {specification.foilingCoils}
            </div>
          )}
          {specification.packingCoils && (
            <div>
              {translate('checkout.cart.specification.packingcoils')}:{' '}
              {specification.packingCoil}
            </div>
          )}
          {specification.maxHeightCoils && (
            <div>
              {translate('checkout.cart.specification.maxheightcoils')}:{' '}
              {specification.maxHeightCoils}
            </div>
          )}
          {specification.maxWeightCoils && (
            <div>
              {translate('checkout.cart.specification.maxweightcoils')}:{' '}
              {specification.maxWeightCoils}
            </div>
          )}
        </Fragment>
      )}
      {blastingDetails && (
        <Fragment>
          {blastingDetails.name && (
            <div>
              {blastingDetails.isPainting
                ? translate('checkout.cart.specification.painting')
                : translate('checkout.cart.specification.blasting')}{': '}
              {blastingDetails.name}
            </div>
          )}
        </Fragment>
      )}
    </Fragment>
  );
};

export default CartCuttingDetails;
